// covered-by: frontends/carrie/src/components/__tests__/Markdown.test.tsx

import { ChatCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import { SOURCE_BADGE_RADIUS_CLASS } from "../ask-puntt-sources/InlineSourceCitation";

/**
 * The chat chip's look, shared by the chip in the answer and its copy on the
 * rail card. Plum, because that is the conversation hue (`--puntt-link-chat`).
 */
export const CHAT_CHIP_CLASS = `puntt-chat-chip inline-flex h-5 items-center justify-center gap-1 ${SOURCE_BADGE_RADIUS_CLASS} px-1.5 text-[11px] font-semibold leading-none`;

export const CHAT_CHIP_STATIC_CLASS = `${CHAT_CHIP_CLASS} puntt-chat-chip--static`;

export function ChatChipFace({ number }: { number: number }) {
  const { t } = useTranslation("ui");
  return (
    <>
      <ChatCircle size={10} weight="duotone" aria-hidden="true" />
      <span>{t("askPuntt.chatCitation.number", { n: number })}</span>
    </>
  );
}

export function ChatChipStatic({
  number,
  testId,
  className = "",
}: {
  number: number;
  testId?: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      data-testid={testId}
      className={`${CHAT_CHIP_STATIC_CLASS} ${className}`.trim()}
    >
      <ChatChipFace number={number} />
    </span>
  );
}
